import { render, staticRenderFns } from "./SkillTagsVoting.vue?vue&type=template&id=59787e1a&"
import script from "./SkillTagsVoting.vue?vue&type=script&lang=ts&"
export * from "./SkillTagsVoting.vue?vue&type=script&lang=ts&"
import style0 from "./SkillTagsVoting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports